module.exports = __webpack_public_path__ + "assets/Instagram.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/Instagram.svg
// module id = 766
// module chunks = 0